import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  Home,
  TrendingUp,
  Phone,
  Calendar
} from "lucide-react";
import { Button } from "../components/ui/button";

export default function BestRateTable() {
  // Create the iframe content with the Acre widget
  const iframeContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <style>
        body { margin: 0; padding: 0; font-family: system-ui, -apple-system, sans-serif; }
        .acre-widget { min-height: 600px; }
      </style>
    </head>
    <body>
      <div class="acre-widget" organisation="cbfc1ad7-84ec-4a4b-8302-7b869c00bd8f" user="494801fd-a617-4caa-a6e2-a2c8da0de4cc">Loading...</div>
      <script src="https://api1.acreplatforms.net/v1/acre/local-sourcing/widget/widget.js"></script>
    </body>
    </html>
  `;

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#020617] via-[#0f172a] to-[#020617] text-white">
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 py-8">
        <Link to="/advisors" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition mb-6">
          <ArrowLeft className="w-4 h-4" />
          Back to Advisors
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <TrendingUp className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold mb-2">Best Rate Table</h1>
          <p className="text-slate-400">Compare today's best mortgage rates from leading UK lenders</p>
        </motion.div>

        {/* Acre Widget in iframe */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="bg-white rounded-2xl overflow-hidden mb-8"
        >
          <iframe
            srcDoc={iframeContent}
            title="Acre Mortgage Rate Widget"
            className="w-full border-0"
            style={{ minHeight: '700px', height: '100%' }}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          />
        </motion.div>

        {/* Disclaimer */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-slate-800/50 backdrop-blur border border-slate-700/50 rounded-2xl p-6 mb-8"
        >
          <p className="text-sm text-slate-400">
            <strong className="text-white">Important:</strong> The rates shown are indicative and subject to change. 
            Your actual rate will depend on your individual circumstances, credit profile, and the lender's criteria at the time of application. 
            For personalized advice, please book a consultation with one of our advisers.
          </p>
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8"
        >
          <a href="tel:07550199399" className="block">
            <Button className="w-full h-14 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-lg">
              <Phone className="w-5 h-5 mr-2" />
              Speak to an Adviser
            </Button>
          </a>
          <Link to="/book-appointment" className="block">
            <Button className="w-full h-14 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-lg">
              <Calendar className="w-5 h-5 mr-2" />
              Book Consultation
            </Button>
          </Link>
        </motion.div>

        {/* Footer */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-center"
        >
          <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition text-sm">
            <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-amber-500 rounded-lg flex items-center justify-center">
              <Home className="w-3 h-3 text-white" />
            </div>
            Thames Mortgage & Protection
          </Link>
          <p className="text-xs text-slate-500 mt-3">FCA Regulated • FRN 1045227</p>
          <p className="text-xs text-amber-500 mt-2 font-medium">Your home may be repossessed if you do not keep up repayments on your mortgage or loans secured on it.</p>
        </motion.div>
      </div>
    </div>
  );
}
